import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import INotificable from '@/Domain/interfaces/INotificable';
import { SdInputDatepicker, SdInputText, SdSelect, SdTag } from '@/Components';
import MasterDataService from '@/Services/MasterDataService';
import i18n from '../../lang/index';
import { NewsChangelogElementRange, NewsChangelogElementTypes } from '@/Domain/enum/NewsChangelog';

@Component({
  components: { SdTag, SdInputText, SdSelect, SdInputDatepicker }
})

export default class NewsChangelog extends Vue {
  dateFormat: string = `D [${i18n.t('lang.shared.from')}] MMMM [${i18n.t('lang.shared.from')}] YYYY`;
  placeholderFormat: string = 'YYYY';
  isLoading: boolean = false;
  newsFunctionalities: INotificable[] = [];
  filterString: string = '';
  elementsType: any = null;
  yearRange: any = null;
  elementsRange: number = 20;
  
  moment: typeof moment = moment;
  newsChangelogElementRange = NewsChangelogElementRange;
  newsChangelogElementTypes = NewsChangelogElementTypes;

  get newsFunctionalitiesTruncated() {
    const arrayCopy = [...this.newFunctionalitiesFilteredByText];

    return arrayCopy.splice(0, this.elementsRange);
  }

  get newFunctionalitiesFilteredByText() {
    return this.newFunctionalitiesFilteredByType.filter(element => element.title.toLowerCase().includes(this.filterString.toLowerCase()));
  }

  get newFunctionalitiesFilteredByType() {
    return this.newFuncionalitiesFilteredByDate.filter(element => element.version!.toLowerCase().includes((i18n.t(this.newsChangelogElementTypes.translations[this.elementsType]) as string).toLowerCase()));
  }

  get newFuncionalitiesFilteredByDate() {
    return this.yearRange 
      ? this.newsFunctionalities.filter(element => moment(element.publicationDate) >= this.dateRange!.start && moment(element.publicationDate) <= this.dateRange!.end)
      : this.newsFunctionalities;
  }

  get dateRange() {
    if (!this.yearRange) { return null; }

    const selectedYear = moment(this.yearRange).year();
    const currentYear = moment().year();

    const yearStart = moment().year(selectedYear).startOf('year');
    const yearEnd = selectedYear === currentYear
      ? moment()
      : moment().year(selectedYear).endOf('year');

    return { start: yearStart, end: yearEnd };
  }

  async getFeatures() {
    this.isLoading = true;
    try {
      const response = await MasterDataService.getNewFeatures();
      if (response && response.length > 0) {
        this.newsFunctionalities = response;
      }
    } catch (error) {
      console.error(error);
    }

    this.isLoading = false;
  }

  async mounted() {
    await this.getFeatures();
  }
}
